// All user related database operations can be defined here.

import { SYSTEM_ERROR } from "../../src/config/CONSTANT";
import axios from 'axios'
import { GET_ALL_Levels} from "../../src/services/CONSTANTS";

/**
 * Function to fetch all the users.
 */
 export const getAllLevel = () => {
  
    
    return new Promise((resolve, reject) => {
      try {
        // do an SDK, DB call or API endpoint axios call here and return the promise.
        let headers = {};
      if (localStorage.getItem("SavedToken") !== null) {
        headers = { Authorization: localStorage.getItem("SavedToken") };
      }
        axios.get(GET_ALL_Levels(),{headers:headers})
        .then((res) => {
        
          console.log(res.data.data , 'res');
  
        //   console.log("getAllMarshalls > axios res=", res);
          resolve(res.data);
       
        })
        .catch((err) => {
        //   console.log("getAllMarshalls > axios err=", err);
          reject("Error in getAllLevel axios!");
        });
      } catch (error) {
        console.error("in levelServices > getAllLevel, Err===", error);
        reject(SYSTEM_ERROR);
      }
    });
  };


  //update level function



